var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header'),_vm._v(" "),_c('Main',{staticClass:"login-main mod-manager"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }